import { HasId2loj0ucxxxo6d as HasId } from '../../../lightning-server-shared/com/lightningkite/lightningdb/HasId.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../../lightning-server-shared/com/lightningkite/UUID.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { $serializer_getInstance1m1pty9fgkr0g as $serializer_getInstance } from './supportModels.mjs';
import { ConditionSerializer21tf3x2n3amih as ConditionSerializer } from '../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionSerialization.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ReadByDataModelClass;
function ReadByDataModel() {
  if (ReadByDataModelClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ReadByDataModel', VOID, VOID, [HasId()]);
    ReadByDataModelClass = $;
  }
  return ReadByDataModelClass;
}
function MarkCreditsRead$Companion$$childSerializers$_anonymous__1uqpjt() {
  return new (ArrayListSerializer())(DeferToContextualUuidSerializer_getInstance());
}
function MarkCreditsRead$Companion$$childSerializers$_anonymous__1uqpjt_0() {
  return new (ConditionSerializer())($serializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, MarkCreditsRead$Companion$$childSerializers$_anonymous__1uqpjt);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d8q_1 = [tmp_1, lazy(tmp_2, MarkCreditsRead$Companion$$childSerializers$_anonymous__1uqpjt_0)];
      }
      k2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.MarkCreditsRead', this, 2);
        tmp0_serialDesc.a1b('itemIds', false);
        tmp0_serialDesc.a1b('additionalCondition', true);
        this.x9m_1 = tmp0_serialDesc;
      }
      y9m(encoder, value) {
        var tmp0_desc = this.x9m_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance().d8q_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.z9m_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.a9n_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, tmp2_cached[1].f2(), value.a9n_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.y9m(encoder, value instanceof MarkCreditsRead() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.x9m_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance().d8q_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return MarkCreditsRead().b9n(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.x9m_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance().d8q_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), get_nullable(tmp0_cached[1].f2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var MarkCreditsReadClass;
function MarkCreditsRead() {
  if (MarkCreditsReadClass === VOID) {
    class $ {
      constructor(itemIds, additionalCondition) {
        Companion_getInstance();
        additionalCondition = additionalCondition === VOID ? null : additionalCondition;
        this.z9m_1 = itemIds;
        this.a9n_1 = additionalCondition;
      }
      toString() {
        return 'MarkCreditsRead(itemIds=' + toString(this.z9m_1) + ', additionalCondition=' + toString_0(this.a9n_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.z9m_1);
        result = imul(result, 31) + (this.a9n_1 == null ? 0 : this.a9n_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MarkCreditsRead()))
          return false;
        if (!equals(this.z9m_1, other.z9m_1))
          return false;
        if (!equals(this.a9n_1, other.a9n_1))
          return false;
        return true;
      }
      static b9n(seen0, itemIds, additionalCondition, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_0().x9m_1);
        }
        var $this = createThis(this);
        $this.z9m_1 = itemIds;
        if (0 === (seen0 & 2))
          $this.a9n_1 = null;
        else
          $this.a9n_1 = additionalCondition;
        return $this;
      }
    }
    initMetadataForClass($, 'MarkCreditsRead', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    MarkCreditsReadClass = $;
  }
  return MarkCreditsReadClass;
}
//region block: exports
export {
  MarkCreditsRead as MarkCreditsRead62qb2liyfwew,
  ReadByDataModel as ReadByDataModel1nk4gz5mxza5s,
  Companion_getInstance as Companion_getInstance1an2l1q3snzzy,
};
//endregion

//# sourceMappingURL=readReceipts.mjs.map
